<template>
  <div id="app" :style="'--beel-primary:' + getPrimaryColor + '; --beel-smooth:' + getSmoothColor + '; --beel-secondary:' + getSecondaryColor + '; --beel-light: ' + getLightColor">
    <Head></Head>
    <router-view></router-view>
    <order-form-layout/>
  </div>
</template>

<script>
import Head from './components/client/Head.vue'
import Booking from './components/client/BookingLayout.vue'
import OrderFormLayout from './components/client/Forms/OrderFormLayout.vue'
import 'animate.css/animate.css'

export default {
  components: { Head, Booking, OrderFormLayout },
  name: 'App',
  computed: {
    getPrimaryColor() {
      if (this.$store.state.adminProperties) {
        return this.$store.state.adminProperties.primaryColor
      } else {
        return "#7F56D9"
      }
    },
    getSmoothColor() {
      if (this.$store.state.adminProperties) {
        return this.$store.state.adminProperties.softColor
      } else {
        return "#53389E"
      }
    },
    getSecondaryColor() {
      if (this.$store.state.adminProperties) {
        return this.$store.state.adminProperties.secondaryColor
      } else {
        return "#E9D7FE"
      }
    },
    getLightColor() {
      if (this.$store.state.adminProperties) {
        return this.$store.state.adminProperties.lightColor
      } else {
        return "#F4EBFF"
      }
    }
  },
  created() {
    this.$store.dispatch('fetchStartData')
  }
}
</script>

<style>
  * {
    margin: 0;
  }

  #app {
    height: 100vh;
    display: flex;
    flex-direction: column;
    --beel-primary: #7F56D9;
    --beel-secondary: #F9F5FF;
  }

  body {
    overflow-x: hidden;
    overflow-y: hidden;
    font-family: 'Inter';
  }
</style>



// WEBPACK FOOTER //
// src/App.vue